<template>
  <button
    class="ca-header__button gap-size-3 px-size-5 py-size-3 rounded-xs"
    :class="{
      'is-hovered': isHovered,
      'is-active': isActive,
      disabled: disabled,
    }"
    :disabled="disabled"
    @click.prevent="!disabled && emit('click')"
    @mouseenter="!disabled && emit('mouseenter')"
    @mouseleave="!disabled && emit('mouseleave')"
    @keydown.enter.prevent="emit('keydown-enter')"
  >
    <slot />
  </button>
</template>

<script setup>
defineProps({
  isHovered: { type: Boolean, default: false },
  isActive: { type: Boolean, default: false },
  disabled: { type: Boolean, default: false },
});

const emit = defineEmits([
  "click",
  "mouseenter",
  "mouseleave",
  "keydown-enter",
]);
</script>

<style scoped lang="scss">
.ca-header__button {
  min-height: 48px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: white;
  border: none;
  cursor: pointer;
  color: var(--ca-color-text-primary);
  -webkit-tap-highlight-color: transparent;

  &:hover {
    background: var(--ca-color-hover-pressed-container-high-hover);
  }
  &.is-hovered {
    background: var(--ca-color-hover-pressed-container-high-hover);
  }
  &.is-active {
    background: var(--ca-color-hover-pressed-container-high-hover);
  }
  &:focus-visible {
    outline: 1px solid var(--ca-color-feedback-info);
  }
  &:active {
    background: var(--ca-color-hover-pressed-container-high-hover);
  }
  &:disabled {
    cursor: not-allowed;
  }
  &.disabled {
    background: transparent;
    opacity: 0.5;
  }
}
</style>
